import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AddCommentOnComponentComponent } from "../../../modules/inspection/create-new-inspection/add-comment-on-component/add-comment-on-component.component";
import {
  AddImageVM,
  BogieCountVM,
  BogieImageModel,
  BogieShim,
  BogieShimNameModel,
} from "./bogie-shim-model";
import { BogieShimService } from "./bogie-shim.service";
import { finalize } from "rxjs/operators";
import { BogieShimHistoryPopUpComponent } from "./bogie-shim-history-popup/bogie-shim-history-popup";
import { GETViewPhotoComponent } from "../../../modules/GET_NEW_UI/shared/view-photo/view-photo.component";
import { PhotoModelComingFrom } from "../../../modules/GET_NEW_UI/inspections/inspection.model";
import { LoadingService } from "../../services/loading.service";
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from 'angular2-notifications';
import { heicTo } from 'heic-to';

@Component({
  selector: "app-bogie-shim",
  templateUrl: "./bogie-shim.component.html",
  styleUrls: ["./bogie-shim.component.scss"],
})
export class BogieShimComponent implements OnInit {
  @Input() inspectionId: number = -1;
  private _side: number | string = -1;
  @Input()
  set side(value: number | string) {
    this._side = value;
  }
  get side(): number {
    if (typeof this._side === "string") {
      const lowerSide = this._side.toLowerCase();
      if (lowerSide === "left" || this._side === "1") return 1;
      if (lowerSide === "right" || this._side === "2") return 2;
    }
    return typeof this._side === "number" ? this._side : -1;
  }
  @Input() bogieShimL: BogieShim[] = [];
  @Input() bogieShimR: BogieShim[] = [];
  @Input() isViewMode: boolean = false;
  @Input() showHistory: boolean = false;
  @Input() equipmentId: number = -1;
  @Input() isInterp: boolean = false;
  photoLoading: boolean = false;
  bogieShimLeft: BogieShim[] = [];
  bogieShimRight: BogieShim[] = [];
  bogieList: BogieShimNameModel[] = [];
  imageUploaded: boolean = false;
  imageUrl: string[] = [];
  equipId: number = -1;
  inspId: number = -1;
  constructor(
    private _dialog: MatDialog,
    private bogieService: BogieShimService,
    private _loading: LoadingService,
    private route: ActivatedRoute,
      private ref: ChangeDetectorRef, private _notify: NotificationsService
  ) {}
  
  ngOnInit() {
    
    this.equipId = +this.route.snapshot.paramMap.get('id');
    this.inspId = +this.route.snapshot.paramMap.get('id2');
 
    console.log("inspectionId", this.inspectionId);
    console.log("side (normalized):", this.side);
    console.log("side (raw):", this._side);
    console.log("Left Shims:", this.bogieShimL);
    console.log("Right Shims:", this.bogieShimR);
    console.log("isViewMode", this.isViewMode);
    console.log("showHistory", this.showHistory);
    console.log("equipmentId", this.equipmentId);
    console.log("isInterp", this.isInterp);
    if (this.isViewMode || this.isInterp) {
      this.loadExistingData();
    } else if (this.inspId <= 0) {
      this.getLeftBogieNames();
      this.getRightBogieNames();
    }
    console.log("Left Shims:", this.bogieShimL);
    console.log("Right Shims:", this.bogieShimR);
    console.log('this.inspId in bogie shim component', this.inspId);
    if(this.inspId > 0){
      this.mapRecords();
    } 
     this.ref.detectChanges();
  }

  mapRecords(){
    if(this.bogieShimL.length > 0){
      this.bogieShimLeft = this.bogieShimL.map(item => ({
        MajorBogie: {
          BogieName: `Major Bogie ${item.BogieNumber}`,
          BogieNumber: item.BogieNumber,
        },
        ShimCount: item.ShimCount,
        Comment: item.Comment || "",
        Images: item.Images.filter((img) => img && img.ImageUrl),
        Side: item.Side,
        InspectionId: item.InspectionId,
        Id: item.BogieNumber,
        BogieNumber: item.BogieNumber,
      }));

      localStorage.setItem("bogieShimLeft", JSON.stringify(this.bogieShimLeft));
    }
    if(this.bogieShimR.length > 0){
      this.bogieShimRight = this.bogieShimR.map(item => ({
        MajorBogie: {
          BogieName: `Major Bogie ${item.BogieNumber}`,
          BogieNumber: item.BogieNumber,
        },
        ShimCount: item.ShimCount,
        Comment: item.Comment || "",
        Images: item.Images.filter((img) => img && img.ImageUrl),
        Side: item.Side,
        InspectionId: item.InspectionId,
        Id: item.BogieNumber,
        BogieNumber: item.BogieNumber,
      }));
      localStorage.setItem("bogieShimRight", JSON.stringify(this.bogieShimRight));

    }
    
    if(this.bogieShimLeft.length == 0 ){
      this.getLeftBogieNames();
    }
    if(this.bogieShimRight.length == 0 ){
      this.getRightBogieNames();
    }
  }

getLeftBogieNames(): void {
  this.bogieService.getBogieShimName().subscribe({
    next: (res) => {
      console.log("raw response (Left)", res);
      this.bogieList = res;

      this.bogieShimLeft = this.bogieList.map((m) => ({
        MajorBogie: m,
        ShimCount: 0,
        Comment: "",
        Images: [],
        Side: 1,
        InspectionId: this.inspectionId,
        Id: m.BogieNumber,
      }));

      console.log("Initialized bogieShimLeft:", this.bogieShimLeft);

      localStorage.setItem("bogieShimLeft", JSON.stringify(this.bogieShimLeft));

      // Force UI update
      this.ref.markForCheck();
      this.ref.detectChanges();
    },
    error: (err) => {
      console.error("Failed to load Left Bogie Names", err);
    }
  });
}

getRightBogieNames(): void {
  this.bogieService.getBogieShimName().subscribe({
    next: (res) => {
      console.log("raw response (Right)", res);
      this.bogieList = res;

      this.bogieShimRight = this.bogieList.map((m) => ({
        MajorBogie: m,
        ShimCount: 0,
        Comment: "",
        Images: [],
        Side: 2,
        InspectionId: this.inspectionId,
        Id: m.BogieNumber,
      }));

      console.log("Initialized bogieShimRight:", this.bogieShimRight);

      localStorage.setItem("bogieShimRight", JSON.stringify(this.bogieShimRight));

      this.ref.markForCheck();
      this.ref.detectChanges();
    },
    error: (err) => {
      console.error("Failed to load Right Bogie Names", err);
    }
  });
}


  // getBogieName() {
  //   this.bogieService.getBogieShimName().subscribe((res) => {
  //     console.log("raw response", res);
  //     this.bogieList = res;
  //     if (this.side == 1) {
  //       this.bogieShimLeft = this.bogieList.map((m) => ({
  //         MajorBogie: m,
  //         ShimCount: 0,
  //         Comment: "",
  //         Images: [],
  //         Side: this.side,
  //         InspectionId: this.inspectionId,
  //         Id: m.BogieNumber,
  //       }));
  //       console.log("bogieShimLeft", this.bogieShimLeft);
  //       localStorage.setItem(
  //         "bogieShimLeft",
  //         JSON.stringify(this.bogieShimLeft)
  //       );
  //     } else if (this.side == 2) {
  //       this.bogieShimRight = this.bogieList.map((m) => ({
  //         MajorBogie: m,
  //         ShimCount: 0,
  //         Comment: "",
  //         Images: [],
  //         Side: this.side,
  //         InspectionId: this.inspectionId,
  //         Id: m.BogieNumber,
  //       }));
  //       console.log("bogieShimRight", this.bogieShimRight);
  //       localStorage.setItem(
  //         "bogieShimRight",
  //         JSON.stringify(this.bogieShimRight)
  //       );
  //     }
  //   });
  // }

  loadExistingData() {
    if (this.bogieShimL?.length > 0) {
      this.bogieShimLeft = this.bogieShimL.map((item) => ({
        MajorBogie: {
          BogieName: `Major Bogie ${item.BogieNumber}`,
          BogieNumber: item.Id,
        },
        ShimCount: item.ShimCount,
        Comment: item.Comment || "",
        Images: item.Images.filter((img) => img && img.ImageUrl),
        Side: item.Side,
        InspectionId: item.InspectionId,
        Id: item.Id,
        BogieNumber: item.BogieNumber,
      }));
      console.log("Loaded bogieShimLeft for display", this.bogieShimLeft);
    }
    if (this.bogieShimR?.length > 0) {
      this.bogieShimRight = this.bogieShimR.map((item) => ({
        MajorBogie: {
          BogieName: `Major Bogie ${item.BogieNumber}`,
          BogieNumber: item.Id,
        },
        ShimCount: item.ShimCount,
        Comment: item.Comment || "",
        Images: item.Images.filter((img) => img && img.ImageUrl),
        Side: item.Side,
        InspectionId: item.InspectionId,
        Id: item.Id,
        BogieNumber: item.BogieNumber,
      }));
      console.log("Loaded bogieShimRight for display", this.bogieShimRight);
    }
  }

  onShimCountChange(bogie: BogieShim) {
    if(!this.isInterp){
      console.log("ShimCount changed:", bogie);
    if (this.side === 1) {
      localStorage.setItem(
        "bogieShimLeft",
        JSON.stringify(this.bogieShimLeft || [])
      );
    } else if (this.side === 2) {
      localStorage.setItem(
        "bogieShimRight",
        JSON.stringify(this.bogieShimRight || [])
      );
    }
    }
    else if(this.isInterp){
      console.log("ShimCount changed:", bogie);
      var countUpdate: BogieCountVM = new BogieCountVM();
      countUpdate.BogieId= bogie.Id,
      countUpdate.Count= bogie.ShimCount;
      this.bogieService.updateCount(countUpdate).subscribe({
        next: (res) => {
           this._notify.success("Shim Count Updated Successfully");
          console.log("Update count response:", res);
        }
      });
    }
  }

  addComment(bogie: BogieShim) {
    const dialogRef = this._dialog.open(AddCommentOnComponentComponent, {
      width: "1032px",
      data: { comment: bogie.Comment, viewMode: this.isViewMode, Interp: this.isInterp, BogieId: bogie.Id },
    });

    dialogRef.afterClosed().subscribe((updatedComment) => {
      if (updatedComment === false || updatedComment === undefined) {
        return;
      }
      //if (updatedComment) {
        bogie.Comment = updatedComment;
        if (this.side == 1) {
          console.log("bogieShimLeft", this.bogieShimLeft);
          localStorage.setItem(
            "bogieShimLeft",
            JSON.stringify(this.bogieShimLeft)
          );
        } else {
          console.log("bogieShimRight", this.bogieShimRight);
          localStorage.setItem(
            "bogieShimRight",
            JSON.stringify(this.bogieShimRight)
          );
        }
      //}
    });
  }

  // onSelectPhoto(event: any, bogie: BogieShim) {
  //   if (event.target.files && event.target.files[0]) {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(event.target.files[0]);
  //     reader.onload = (e: any) => {
  //       this.compressImage(e.target.result).then((res: string) => {
  //         if (res) {
  //           this.uploadPhoto(res.split(",")[1], bogie);
  //         }
  //       });
  //     };
  //   }
  // }



  // onSelectPhoto(event: any, bogie: BogieShim) {
  //   if (event.target.files && event.target.files[0]) {
  //     bogie.photoLoading = true;
  //     this.imageUploaded = true;
  //     //this._cdr.detectChanges();
  //     let file = event.target.files[0];
  //     const isHeic = file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic");
  //     const processFile = (f: File) => {
  //       const reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         this.compressImage(e.target.result).then((res: string) => {
  //           if (res) {
  //             this.uploadPhoto(res.split("," )[1], bogie);
  //           }
  //         })
  //       };
  //       reader.readAsDataURL(f);
  //     };
  //     if (isHeic) {
  //       (heic2any as any).default({
  //         blob: file,
  //         toType: "image/jpeg",
  //         quality: 0.8
  //       })
  //       .then((result: any) => {
  //         const convertedBlob = Array.isArray(result) ? result[0] : result;
  //         const convertedFile = new File([convertedBlob], "converted.jpg", {
  //           type: "image/jpeg"
  //         });
  //         processFile(convertedFile);
  //       })
  //       .catch((err: any) => {
  //         bogie.photoLoading = false;
  //         this.imageUploaded = false;
  //         console.error("HEIC conversion failed", err);
  //         this._notify.error('Error', 'Unable to update the photo. Please contact support.');
  //       });
  //     } else {
  //       processFile(file);
  //     }
  //     event.target.value = null;
  //   }
  // }

  async onSelectPhoto(event: any, bogie: BogieShim): Promise<void> {

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  bogie.photoLoading = true;
  this.imageUploaded = true;

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    const reader = new FileReader();

    reader.onload = (e: any) => {

      this.compressImage(e.target.result)
        .then((res: string) => {

          if (res) {
            this.uploadPhoto(res.split(",")[1], bogie);
          }

        })
        .catch(err => {

          bogie.photoLoading = false;
          this.imageUploaded = false;
          console.error(err);

        });

    };

    reader.readAsDataURL(f);

  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg", // Change to "toType" if required by your heic-to version
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    bogie.photoLoading = false;
    this.imageUploaded = false;

    console.error("HEIC conversion failed", err);

    this._notify.error(
      "Error",
      "Unable to update the photo. Please contact support."
    );

  }

  // Allow selecting the same file again
  event.target.value = null;

}

  private compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement("canvas");
        let width, height;
        width = img.width;
        height = img.height;
        console.log("width", width);
        console.log("height", height);
        var ratio = height / width;
        let imageWidth = 800;
        var new_height = imageWidth * ratio;
        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext("2d");
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      };
      img.onerror = (error) => rej(error);
    });
  }

  uploadPhoto(base64Photo: string, bogie: BogieShim) {
    if (!bogie) return;
    bogie.photoLoading = true;
    this.imageUploaded = true;
    bogie.Images = bogie.Images || [];
    this.bogieService
      .getAWSImagePath(base64Photo)
      .pipe(finalize(() => (bogie.photoLoading = false)))
      .subscribe({
        next: (imagePath: BogieImageModel) => {
          bogie.Images.push({
            ImageId: null,
            ImagePath: imagePath.ImagePath,
            ImageUrl: imagePath.ImageUrl,
          });
          this.imageUrl.push(imagePath.ImageUrl);
          console.log("this.imageUrl", this.imageUrl);
          if (this.side === 1) {
            localStorage.setItem(
              "bogieShimLeft",
              JSON.stringify(this.bogieShimLeft || [])
            );
          } else if (this.side === 2) {
            localStorage.setItem(
              "bogieShimRight",
              JSON.stringify(this.bogieShimRight || [])
            );
          }
          //this.imageUploaded = false;
           bogie.photoLoading = false;
      if(this.isInterp){
        var addImageModel: AddImageVM = new AddImageVM();
        addImageModel.BogieId= bogie.Id;
        addImageModel.BogieNumber= bogie.BogieNumber;
        addImageModel.Image= imagePath.ImagePath;
        this.bogieService.addBogieShimPhoto(addImageModel).subscribe({
          next: (res) => {
            this._notify.success("Image Added Successfully");
            console.log(this.bogieShimLeft);
          }
        });
      }
    },
      error: (err) =>{
        this._notify.error("Image Upload Failed");
         console.error("Upload failed", err)
      } 
    });
  }

  viewHistory(s: number) {
    console.log(
      "this.bogieShimL[0].InspectionId",
      this.bogieShimL[0].InspectionId
    );
    console.log(
      "this.bogieShimLeft[0].InspectionId",
      this.bogieShimLeft[0].InspectionId
    );
    const dialogRef = this._dialog.open(BogieShimHistoryPopUpComponent, {
      width: "800px",
      data: { EquipmentId: this.equipmentId, Side: s },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }

  ViewInspectionImage(img: string, id: number) {
    if(!this.isInterp && !this.isViewMode) {
      var passingData = {
      comingFrom: PhotoModelComingFrom.BogieNewInspectionImage,
      image: img.replace('Thumbnail_S', ''),
      Id: id,
      ImageUrl: true,
      IsViewMode: false
    };
    }
    if(this.isInterp && !this.isViewMode) {
      var passingData = {
      comingFrom: PhotoModelComingFrom.BogieInterpImage,
      image: img.replace('Thumbnail_S', ''),
      Id: id,
      ImageUrl: true,
      IsViewMode: false
    };
    }
    if(this.isViewMode) {
      var passingData = {
      comingFrom: PhotoModelComingFrom.BogieImageEquipmentPage,
      image: img.replace('Thumbnail_S', ''),
      Id: id,
      ImageUrl: true,
      IsViewMode: !!this.isViewMode
    };
    }
    const viewInspectionPhoto = this._dialog.open(GETViewPhotoComponent, {
      width: "1032px",
      data: passingData,
    });
    viewInspectionPhoto.afterClosed().subscribe((result) => {
      if (result.Action === "delete") {
        if (this.side === 1) {
          this.bogieShimLeft.forEach((bogie) => {
            bogie.Images = bogie.Images.filter((img) => img.ImageId !== id);
          });
          localStorage.setItem("bogieShimLeft",JSON.stringify(this.bogieShimLeft));
             this._loading.finishedLoading();
        }
        else if (this.side === 2) {
          this.bogieShimRight.forEach((bogie) => {
            bogie.Images = bogie.Images.filter((img) => img.ImageId !== id);
          });
           localStorage.setItem("bogieShimRight", JSON.stringify(this.bogieShimRight));
            this._loading.finishedLoading();
        }
      }
      if(result.Action === "deleteInerp") {
         if (this.side === 1) {
          this.bogieShimLeft.forEach((bogie) => {
            bogie.Images = bogie.Images.filter((img) => img.ImageId !== id);
          });
             this._loading.finishedLoading();
        }
        else if (this.side === 2) {
          this.bogieShimRight.forEach((bogie) => {
            bogie.Images = bogie.Images.filter((img) => img.ImageId !== id);
          });
          this._loading.finishedLoading();
        }
      }
      if(result.Action === "updateInterp") {
        if (this.side === 1) {
          this.bogieShimLeft.forEach((bogie) => {
            const idx = bogie.Images.findIndex((img) => img.ImageId == id);
             bogie.Images[idx].ImagePath = result.Data.m_Item3;
             bogie.Images[idx].ImageUrl = result.Data.m_Item4;
          });
             this._loading.finishedLoading();
        }
        else if (this.side === 2) {
          this.bogieShimRight.forEach((bogie) => {
            const idx = bogie.Images.findIndex((img) => img.ImageId == id);
             bogie.Images[idx].ImagePath = result.Data.m_Item3;
             bogie.Images[idx].ImageUrl = result.Data.m_Item4;
          });
          this._loading.finishedLoading();
        }
      }
    });
  }

  ValidateNumberInputs(e) {
    if (e.keyCode != 8 && e.keyCode != 0 && (e.keyCode < 48 || e.keyCode > 57)) {
       return false;
    }
  }
}
